import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";

import AboutBackApp from "./aboutbackapp";
import Contact from "./contact";
import Footer from "./footer";
import Home from "./home";
import Navbar from "./navbar";
import Services from "./Services";
import Assistant from './assistant';
import Benefits from './benefits';
import AreaTeam from './areateam';
import WhatsappFloat from './wsp';
import '@fortawesome/fontawesome-free/css/all.min.css';


const Index = () => {
  document.title = " BackApp Chile";

  window.onscroll = function () {
    scrollFunction();
  };

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <React.Fragment>
      <div className="layout-wrapper landing">
        <Navbar />
        <Home />
        <AboutBackApp />
        <Services />
        <Benefits />
        <Assistant />
        <AreaTeam />
        <Contact />
        <Footer />
        <WhatsappFloat />
        <button
          onClick={toTop}
          className="btn-modern-top"
          id="back-to-top"
          aria-label="Volver arriba"
        >
          ↑
        </button>
      </div>
    </React.Fragment>
  );
};

export default Index;
//<button
//        onClick={() => toTop()}
//          className="btn btn-danger btn-icon landing-back-top"
//          id="back-to-top"
//        >
//          <i className="ri-arrow-up-line"></i>
//        </button>